module.exports = __webpack_public_path__ + "img/jotweb_logo.4ca91c40.png";